module.exports = __webpack_public_path__ + "img/3dStitchedBag.c75a90d2.jpg";